export default "/build/frontend/fonts/vendor/lightgallery/lg.woff2?64b800aa30714fd916dce5018ba7ad76";